import { WHATSAPP_ONBOARDING_STEPS } from '@repo/shared-types';

import type { WhatsAppOnboarding } from '@repo/shared-types';

const CODE_FALLBACK_MS = 120_000;

const LABELS: Record<(typeof WHATSAPP_ONBOARDING_STEPS)[number], string> = {
  preflight: 'Check the number and SMS routing',
  add_number: 'Add the number to the business account',
  request_code: 'Request the verification code',
  verify_code: 'Verify the code',
  register: 'Register for messaging',
  enable_calling: 'Enable calling',
  subscribe: 'Subscribe webhooks',
  sync: 'Add to the platform',
};

export type StepState = 'todo' | 'active' | 'ok' | 'failed';

export interface OnboardingStepView {
  key: (typeof WHATSAPP_ONBOARDING_STEPS)[number];
  label: string;
  state: StepState;
}

export interface OnboardingView {
  steps: OnboardingStepView[];
  showCodeBox: boolean;
  /** Seconds left before the code can be typed by hand (Twilio route only). */
  secondsUntilCodeBox: number | null;
}

export function describeOnboarding(record: WhatsAppOnboarding, now: Date): OnboardingView {
  const currentIndex = WHATSAPP_ONBOARDING_STEPS.indexOf(record.step);
  const steps = WHATSAPP_ONBOARDING_STEPS.map((key, index) => {
    let state: StepState = 'todo';
    if (record.status === 'done' || index < currentIndex) state = 'ok';
    else if (index === currentIndex) state = record.status === 'failed' ? 'failed' : 'active';
    return { key, label: LABELS[key], state };
  });

  let showCodeBox = false;
  let secondsUntilCodeBox: number | null = null;
  if (record.status === 'waiting_code') {
    if (!record.twilio_phone_number_id) {
      showCodeBox = true;
    } else {
      const requested = record.code_requested_at
        ? new Date(record.code_requested_at).getTime()
        : now.getTime();
      const elapsed = now.getTime() - requested;
      secondsUntilCodeBox = Math.max(0, Math.ceil((CODE_FALLBACK_MS - elapsed) / 1000));
      showCodeBox = elapsed > CODE_FALLBACK_MS;
    }
  }

  return { steps, showCodeBox, secondsUntilCodeBox };
}
